<template>
    <div style="position:relative">
        <compFormEdit class="margin-top-15 margin-right-15" ref="supplierEditForm" :formdata="getBase" v-model="formData" :labelWidth="80" :col="1"/>
        <div class="text-right">
            <vButton theme="primary" @click="submit">保存</vButton>
            <vButton class="margin-left-10" @click="cancel">取消</vButton>
        </div>

        <!-- 全局弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" ></component>
            <!-- <footer slot="footer" v-show="false"></footer> -->
        </compModal>
        <vLoading fix :loading="loading"></vLoading>
    </div>
</template>
<script>
import { HttpCheckRecommend, HttpUnCategory } from "@/service/proddevelop";
import { HttpGetCategories } from '@/service/products/allproducts'
import searchCategory from "../../products/searchcategory/index";

export default {
    props:['orderid','categoryid','soucetype','categoryone'],
    data(){
        return {
            categoryList:[],
            formData:{
                categoryId:this.categoryid || 0,
            },
            modalProps:{
                show:false,
                title:"",
                component: null
            },
            loading:false,
        }
    },components: {
        searchCategory,
	},
    created(){
        this.getcategory()
    },
    computed:{
        getBase(){
            return [
                {
					label: "品类",
                    key: "categoryName",
                    children: (h) => {
						return <vIcon
							title={this.$t('erp.product.search_category',{defaultValue:'搜索品类'})}
							type="search"
							center
							slot="suffix"
							style="padding:6px;pointer-events: initial;"
							size="18"
							nativeOnClick={this.handleModalplat.bind(this)}
						/>
					},
					props: {
                        readonly: true,
                        placeholder:this.$t('erp.product.select_category',{defaultValue:'请选择品类'})
					},
                },
                {
					label: "备注",
                    key:'remark',
                    tag: "vTextarea",
                    required:false,
                    show:this.soucetype!='list'
                },
            ]
        }
    },
    methods:{
        handleModalplat(){
            this.modalProps = {
                title:'搜索品类',
                show:true,
                width:650,
                component: "searchCategory",
                showFooter:false,
                on:{
                    'on-chosedata':(data)=>{
                        console.log(data)
                        this.$set(this.formData,'categoryName',data.code+'-'+data.name);
                        this.$set(this.formData,'categoryId',data.id);

                        
                        this.modalProps = {}
                    }
                }
            }
        },
        getcategory(){
            this.loading = true;
            this.formData.categoryName = this.categoryone
            HttpGetCategories().then(res=>{
                this.categoryList = res.data.filter(item=>{
                    return item.level == 3
                })
                this.loading = false;
            })
        },
        async submit(){
            if(this.soucetype === 'list'){
                HttpUnCategory({
                    categoryId:this.formData.categoryId,
                    id:this.orderid,
                }).then(res=>{
                    this.$VMessage.success(res.message);
                    this.$emit('on-update');
                },err=>{

                })
            }else{
                HttpCheckRecommend({
                    statusId:2,
                    categoryId:this.formData.categoryId,
                    ids:this.orderid,
                }).then(res=>{
                    this.$emit('on-update')
                })
            }
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>